const LEFT_PAGE = "LEFT";
const RIGHT_PAGE = "RIGHT";

export { LEFT_PAGE, RIGHT_PAGE };
